import { StyledCategoryCard } from './style';
import { CategoryData } from 'types/CategoryData';
import { useIntl } from 'react-intl';
import { FallbackImage } from '../UploadImage/fallBack/FallBackImage';
import { useNavigate } from 'react-router-dom';
import RoutesPath from 'enums/routes';

export interface CategoryCardProps {
  bordered?: boolean;
  hoverable?: boolean;
  category?: CategoryData;
  img?: string;
  imageUrl?: string;
}

export const CategoryCard = ({
  bordered,
  hoverable,
  imageUrl,
  category,
}: CategoryCardProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const coverImg = (
    <FallbackImage src={imageUrl || ''} type={'CategoryCard'} preview={false} />
  );

  const getFilterState = (category?: CategoryData) => {
    let state = {
      category: '',
      subCategory: '',
      subSubcategory: '',
    };

    if (!category) return state;

    switch (category.level) {
      case 0:
        state.category = String(category.id);
        break;
      case 1:
        state.category = String(category.sub_id);
        state.subCategory = String(category.id);
        break;
      case 2:
        state.category = String(category.sub_sub_id);
        state.subCategory = String(category.sub_id);
        state.subSubcategory = String(category.id);
        break;
      default:
        console.warn('Unknown category level:', category.level);
    }

    return state;
  };

  const handleClick = () => {
    if (!category?.id) return;
    navigate(RoutesPath.PRODUCTS_ALL, {
      state: getFilterState(category),
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <StyledCategoryCard
      bordered={bordered}
      cover={coverImg}
      hoverable={hoverable}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className={'category-title'}>
        <p>{category?.name}</p>
      </div>
      <div className={'product-count'}>
        <p>
          {category?.product_count}{' '}
          {intl.formatMessage({ id: 'general.products' })}
        </p>
      </div>
    </StyledCategoryCard>
  );
};
